import { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Botao } from '../../../components/Botao';
import { Checkbox } from '../../../components/Checkbox';
import { CorpoDaPagina } from '../../../components/CorpoDaPagina';
import { Input } from '../../../components/Input';
import { Seletor } from '../../../components/Seletor';
import { InstituicaoStore } from '../../../stores/InstituicaoStore';
import { MunicipioStore } from '../../../stores/MunicipioStore';
import { ButtonContainer, Conteiner, Formulario, ConteinerCampos } from './styles';

function InstituicaoFormulario() {
  const [editar, atribuirEditar] = useState(false);
  const [instituicao, atribuirInstituicao] = useState({});
  const [municipios, atribuirMunicipios] = useState([]);
  const [visivel, atribuirVisivel] = useState(false);

  const formulario = useRef(null);

  const historico = useHistory();

  const { pathname } = useLocation();

  const { id } = useParams();

  const enviarFormulario = useCallback(
    async (data) => {
      formulario.current?.setErrors({});
      let error = false;

      if (data.nome === '') {
        formulario.current?.setFieldError('nome', 'Campo obrigatório');
        error = true;
      }
      if (data.codigoIE === '') {
        formulario.current?.setFieldError('codigoIE', 'Campo obrigatório');
        error = true;
      }
      if (data.dependenciaAdministrativa === '') {
        formulario.current?.setFieldError('dependenciaAdministrativa', 'Campo obrigatório');
        error = true;
      }
      if (data.cidade === '') {
        formulario.current?.setFieldError('cidade', 'Campo obrigatório');
        error = true;
      }
      if (data.modalidades.length === 0) {
        formulario.current?.setFieldError('modalidades', 'Selecione pelo menos uma modalidade');
        error = true;
      }

      if (error) {
        return;
      }

      if (editar) {
        await InstituicaoStore.editar(id, data).then((response) => {
          if (response.status === 200) {
            toast.success(response.data.mensagem);
            historico.push('/instituicao');
          } else {
            toast.error(response.data.mensagem);
          }
        });
      } else {
        await InstituicaoStore.criar(data).then((response) => {
          if (response.status === 201) {
            toast.success(response.data.mensagem);
            historico.push('/instituicao');
          } else {
            toast.error(response.data.mensagem);
          }
        });
      }
    },
    [historico, editar, id],
  );

  useEffect(() => {
    const callView = async () => {
      await MunicipioStore.obterMunicipios().then((response) => {
        if (response.status === 200) {
          atribuirMunicipios([
            { label: 'Selecione', value: '' },
            ...response.data.map((item) => ({ label: item.nome, value: item.nome })),
          ]);
        } else if (response.status === 204) {
          toast.error('Não há municípios cadastrados');
        } else toast.error(response.data.mensagem);
      });
    };

    if (pathname.toUpperCase().includes('VISUALIZAR')) atribuirVisivel(true);
    if (pathname.toUpperCase().includes('EDITAR')) atribuirEditar(true);

    callView();
  }, []);

  useEffect(() => {
    const callView = async () => {
      if (
        municipios.length > 0 &&
        (pathname.toUpperCase().includes('VISUALIZAR') || pathname.toUpperCase().includes('EDITAR'))
      ) {
        await InstituicaoStore.obterPorId(id).then((response) => {
          if (response.status === 200) {
            atribuirInstituicao(response.data);
          } else {
            toast.error(response.data.mensagem);
          }
        });
      }
    };

    callView();
  }, [municipios, pathname, id]);

  return (
    <CorpoDaPagina
      voltar
      titulo={`${visivel || editar ? 'Instituição ' + id : 'Nova Instituição'}`}
    >
      <Conteiner>
        <Formulario ref={formulario} onSubmit={enviarFormulario} initialData={instituicao}>
          <ConteinerCampos>
            <Input
              nome='nome'
              titulo='Nome da Instituição'
              desabilitado={visivel}
              placeholder={'Informe o nome'}
            />
          </ConteinerCampos>
          <ConteinerCampos>
            <Seletor
              nome='dependenciaAdministrativa'
              titulo='Dependência administrativa'
              desabilitado={visivel}
              opcoes={[
                { label: 'Selecione', value: '' },
                { label: 'Federal', value: 'Federal' },
                { label: 'Privada', value: 'Privada' },
                { label: 'Municipal', value: 'Municipal' },
                { label: 'Estadual', value: 'Estadual' },
              ]}
            />
            <Input
              nome='codigoIE'
              titulo='Código da instituição'
              desabilitado={visivel}
              mascara
              tipoDeMascara='codIE'
              comprimentoMaximo={8}
              placeholder={'Informe o código da instituição'}
            />
            <Seletor nome='cidade' titulo='Município' opcoes={municipios} desabilitado={visivel} />
          </ConteinerCampos>
          <ConteinerCampos>
            <Checkbox
              nome='modalidades'
              titulo='Etapas e modalidades de ensino ofertadas pela instituição'
              desabilitado={visivel}
              opcoes={[
                { label: 'EAD - Superior' },
                { label: 'Presencial - Superior' },
                { label: 'Ensino Fundamental' },
                { label: 'Ensino Médio' },
                { label: 'Educação de Jovens Adultos' },
                { label: 'Educação Profissional' },
                { label: 'Educação Infantil' },
              ]}
            />
          </ConteinerCampos>
          {!visivel && (
            <ConteinerCampos>
              <ButtonContainer>
                <Botao tipo='submit' texto='Salvar' cor='primary' />
              </ButtonContainer>
            </ConteinerCampos>
          )}
        </Formulario>
      </Conteiner>
    </CorpoDaPagina>
  );
}

export default InstituicaoFormulario;
